var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":"添加词条"}},[_c('img',{staticClass:"func-img",attrs:{"src":"https://bookor-application.oss-cn-beijing.aliyuncs.com/create.png"},on:{"click":_vm.onClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }